'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class StoreAreaTypes extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'sort_order',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
		];
		this.settings = {
			name: 'StoreAreaTypes',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canManipulate: () => validAccess(undefined, ['Global HR Configuration']),
			translationPath: 'ADMINISTRATION.STORE_AREA_TYPES',
			endpoint: __endpoints.collection.administration.store_area_types,
		};
		this.init();
		return this;
	}
}
